import { useCallback, useEffect, useState } from "react";
import { ICustomerDeliveryAddress } from "../common/interfaces";
import { DeliveryAddressService } from "../services/DeliveryAddressService";

/**
 * Direcciones de entrega guardadas de un cliente. El costo de envío de cada
 * una lo cotiza el backend (ver useShippingCalculator). Reusado por orderOptions.tsx.
 */
export const useCustomerDeliveryAddresses = (customerId?: number) => {
  const [addresses, setAddresses] = useState<ICustomerDeliveryAddress[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    if (!customerId) {
      setAddresses([]);
      return;
    }
    setLoading(true);
    DeliveryAddressService.getByCustomer(customerId)
      .then((res) => {
        setAddresses((res.data ?? []) as ICustomerDeliveryAddress[]);
      })
      .finally(() => setLoading(false));
  }, [customerId]);

  useEffect(() => {
    load();
  }, [load]);

  const createAddress = async (payload: {
    name: string;
    address: string;
    number?: string;
    lat?: number;
    lng?: number;
  }): Promise<ICustomerDeliveryAddress | undefined> => {
    if (!customerId) return undefined;
    const res = await DeliveryAddressService.create({ ...payload, customer_id: customerId });
    load();
    return res.data;
  };

  return { addresses, loading, reload: load, createAddress };
};
